import { createReducer, on } from "@ngrx/store";
import { ReleaseActions } from "../actions/release.actions";
import { initialState } from "../states/release.state";

export const releaseReducer = createReducer(
  initialState,

  // Load Releases
  on(ReleaseActions.loadRelease, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ReleaseActions.loadReleaseSuccess, (state, { releaseList }) => ({
    ...state,
    loading: false,
    releaseList,
  })),

  on(ReleaseActions.loadReleaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Release
  on(ReleaseActions.createRelease, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ReleaseActions.createReleaseSuccess, (state, { release }) => ({
    ...state,
    loading: false,
    releaseList: [...state.releaseList, release],
  })),

  on(ReleaseActions.createReleaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Release
  on(ReleaseActions.updateRelease, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ReleaseActions.updateReleaseSuccess, (state, { release }) => ({
    ...state,
    loading: false,
    releaseList: state.releaseList.map((r: any) =>
      r.id === release?.id ? { ...r, ...release } : r
    ),
  })),

  on(ReleaseActions.updateReleaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Remove Release
  on(ReleaseActions.removeRelease, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ReleaseActions.removeReleaseSuccess, (state, { releaseIdList }) => ({
    ...state,
    loading: false,
    releaseList: state.releaseList.filter(
      (release: any) => !releaseIdList.includes(release.id)
    ),
  })),
  on(ReleaseActions.removeReleaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
